// Store Swiper instances globally
let sliderThumbs = null;
let sliderMain = null;

function initializeSliders() {
  // Destroy previous instances if they exist
  if (sliderThumbs && typeof sliderThumbs.destroy === "function") {
    sliderThumbs.destroy(true, true);
  }
  if (sliderMain && typeof sliderMain.destroy === "function") {
    sliderMain.destroy(true, true);
  }

  // Initialize thumbnails slider if present
  const thumbEl = document.querySelector(".product-slider--thumbnails");
  if (thumbEl && thumbEl.children.length > 0) {
    sliderThumbs = new Swiper(thumbEl, {
      slidesPerView: 6,
      direction: "vertical",
    });
  } else {
    sliderThumbs = null;
  }

  // Initialize main slider if present
  const mainEl = document.querySelector(".product-slider--main");
  if (mainEl) {
    sliderMain = new Swiper(mainEl, {
      watchOverflow: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      preventInteractionOnTransition: true,
      draggable: false,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      effect: "fade",
      fadeEffect: { crossFade: true },
      thumbs: sliderThumbs ? { swiper: sliderThumbs } : {},
      on: {
        slideChange: function () {
          const currentIndex = this.realIndex + 1;
          const counter = document.querySelector(".swiper-counter--current");
          if (counter) counter.textContent = currentIndex;
        },
      },
    });
  }

  const infoSection = document.querySelector(".single-info-section");
  if (infoSection && thumbEl === null) {
    infoSection.classList.add("single-info-section--full-width");
  } else {
    infoSection.classList.remove("single-info-section--full-width");
  }
}

// Initialize on load
document.addEventListener("DOMContentLoaded", initializeSliders);

// Initialize after variant change
document.addEventListener("variant:change", initializeSliders);
